(function () {
  var root = document.querySelector('[data-vpc-root]');
  if (!root) return;

  var grid = root.querySelector('[data-vpc-grid]');
  var nextBtn = root.querySelector('[data-vpc-next]');
  var sentinel = root.querySelector('[data-vpc-sentinel]');
  var sort = root.querySelector('[data-vpc-sort]');
  var toggle = root.querySelector('[data-vpc-filter-toggle]');
  var drawer = root.querySelector('[data-vpc-drawer]');
  var facets = root.querySelector('[data-vpc-facets]');
  var sidebar = root.querySelector('[data-vpc-sidebar]');
  var drawerSlot = root.querySelector('[data-vpc-drawer-slot]');
  var chips = root.querySelector('[data-vpc-chips]');
  var empty = root.querySelector('[data-vpc-empty]');
  var countEl = root.querySelector('[data-vpc-result-count]');
  var loading = false;
  var observer;
  var groups = ['make', 'model', 'year', 'fuel'];

  function go(url) {
    if (!url) return;
    window.location.href = url;
  }

  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      go(url.toString());
    });
  }

  function placeFilters() {
    if (!facets) return;
    if (window.matchMedia('(max-width: 991px)').matches) {
      if (drawerSlot && facets.parentNode !== drawerSlot) drawerSlot.appendChild(facets);
    } else if (sidebar && facets.parentNode !== sidebar) {
      sidebar.appendChild(facets);
    }
  }
  placeFilters();
  window.addEventListener('resize', placeFilters);

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      placeFilters();
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeDrawer();
    });
    root.querySelectorAll('[data-vpc-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function selected(name) {
    if (!facets) return [];
    return Array.prototype.map.call(
      facets.querySelectorAll('input[name="' + name + '"]:checked'),
      function (el) { return el.value; }
    );
  }

  function priceVal(name) {
    if (!facets) return 0;
    var el = facets.querySelector('input[name="' + name + '"]');
    var n = el && el.value ? parseInt(el.value, 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  function cards() {
    return root.querySelectorAll('[data-vpc-card]');
  }

  function matches(card, skip) {
    var price = parseInt(card.getAttribute('data-vpc-price') || '0', 10);
    var min = priceVal('price_min') * 100;
    var max = priceVal('price_max') * 100;
    if (skip !== 'price') {
      if (min && price < min) return false;
      if (max && price > max) return false;
    }
    for (var i = 0; i < groups.length; i++) {
      var key = groups[i];
      if (skip === key) continue;
      var vals = selected(key);
      if (!vals.length) continue;
      if (vals.indexOf(card.getAttribute('data-vpc-' + key) || '') === -1) return false;
    }
    return true;
  }

  function placeTrucks() {
    if (!grid) return;
    var featured = [];
    var available = [];
    var sold = [];
    cards().forEach(function (card) {
      if (card.getAttribute('data-vpc-order-in') === 'true') featured.push(card);
      else if (card.getAttribute('data-vpc-sold') === 'true') sold.push(card);
      else available.push(card);
    });
    featured.forEach(function (card) { grid.appendChild(card); });
    available.forEach(function (card) { grid.appendChild(card); });
    sold.forEach(function (card) { grid.appendChild(card); });
  }

  function apply() {
    placeTrucks();
    var visible = 0;
    cards().forEach(function (card) {
      var ok = matches(card);
      card.classList.toggle('is-filtered-out', !ok);
      if (ok) visible += 1;
    });
    if (countEl) {
      countEl.textContent = visible + (visible === 1 ? ' truck' : ' trucks');
    }
    if (empty) empty.hidden = visible !== 0;
    if (grid) grid.style.display = visible === 0 ? 'none' : '';
    if (toggle) {
      var n = activeCount();
      toggle.textContent = n ? 'Filters (' + n + ')' : 'Filters';
    }
    updateCounts();
    renderChips();
    writeURL();
  }

  function activeCount() {
    var n = groups.reduce(function (sum, key) { return sum + selected(key).length; }, 0);
    if (priceVal('price_min') || priceVal('price_max')) n += 1;
    return n;
  }

  function updateCounts() {
    if (!facets) return;
    groups.forEach(function (key) {
      facets.querySelectorAll('input[name="' + key + '"]').forEach(function (input) {
        var n = 0;
        cards().forEach(function (card) {
          if ((card.getAttribute('data-vpc-' + key) || '') !== input.value) return;
          if (matches(card, key)) n += 1;
        });
        var countNode = facets.querySelector('[data-vpc-count="' + key + ':' + input.value + '"]');
        if (countNode) countNode.textContent = n;
        var row = input.closest('li');
        if (row) row.classList.toggle('is-empty', n === 0 && !input.checked);
      });
    });
  }

  function renderChips() {
    if (!chips) return;
    chips.innerHTML = '';
    var n = activeCount();
    chips.hidden = n === 0;
    if (!n) return;
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'vpc-chip vpc-chip--clear';
    clear.textContent = 'Clear all';
    clear.addEventListener('click', clearAll);
    chips.appendChild(clear);
    if (!facets) return;
    facets.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
      var label = input.parentNode.querySelector('span');
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'vpc-chip is-active';
      chip.textContent = label ? label.textContent : input.value;
      chip.addEventListener('click', function () {
        input.checked = false;
        apply();
      });
      chips.appendChild(chip);
    });
    var min = priceVal('price_min');
    var max = priceVal('price_max');
    if (min || max) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'vpc-chip is-active';
      chip.textContent = (min ? '$' + min.toLocaleString() : '$0') + ' – ' + (max ? '$' + max.toLocaleString() : 'Any');
      chip.addEventListener('click', function () {
        var a = facets.querySelector('input[name="price_min"]');
        var b = facets.querySelector('input[name="price_max"]');
        if (a) a.value = '';
        if (b) b.value = '';
        apply();
      });
      chips.appendChild(chip);
    }
  }

  function writeURL() {
    var url = new URL(window.location.href);
    groups.forEach(function (key) { url.searchParams.delete(key); });
    url.searchParams.delete('type');
    url.searchParams.delete('price_min');
    url.searchParams.delete('price_max');
    groups.forEach(function (key) {
      selected(key).forEach(function (val) { url.searchParams.append(key, val); });
    });
    var min = priceVal('price_min');
    var max = priceVal('price_max');
    if (min) url.searchParams.set('price_min', String(min));
    if (max) url.searchParams.set('price_max', String(max));
    window.history.replaceState({}, '', url.toString());
  }

  function readURL() {
    if (!facets) return;
    var url = new URL(window.location.href);
    groups.forEach(function (key) {
      var vals = url.searchParams.getAll(key);
      facets.querySelectorAll('input[name="' + key + '"]').forEach(function (input) {
        input.checked = vals.indexOf(input.value) !== -1;
      });
    });
    var min = facets.querySelector('input[name="price_min"]');
    var max = facets.querySelector('input[name="price_max"]');
    if (min) min.value = url.searchParams.get('price_min') || '';
    if (max) max.value = url.searchParams.get('price_max') || '';
  }

  function clearAll() {
    if (!facets) return;
    facets.querySelectorAll('input[type="checkbox"]').forEach(function (el) { el.checked = false; });
    var min = facets.querySelector('input[name="price_min"]');
    var max = facets.querySelector('input[name="price_max"]');
    if (min) min.value = '';
    if (max) max.value = '';
    apply();
  }

  root.querySelectorAll('[data-vpc-clear]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      clearAll();
    });
  });

  if (facets) {
    facets.addEventListener('change', function (e) {
      if (!e.target) return;
      ensureAllLoaded().then(apply);
    });
    facets.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.tagName === 'INPUT') {
        e.preventDefault();
        ensureAllLoaded().then(apply);
      }
    });
  }

  function stopPaging() {
    if (nextBtn && nextBtn.parentNode) nextBtn.parentNode.removeChild(nextBtn);
    nextBtn = null;
    if (observer && sentinel) observer.unobserve(sentinel);
    if (sentinel && sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
    sentinel = null;
  }

  function loadNext() {
    if (!nextBtn || loading) return Promise.resolve();
    var href = nextBtn.getAttribute('href');
    if (!href) return Promise.resolve();
    loading = true;
    nextBtn.classList.add('is-loading');
    nextBtn.textContent = 'Loading…';

    return fetch(href, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-vpc-root]') || doc;
        incoming.querySelectorAll('[data-vpc-card]').forEach(function (card) {
          if (grid) grid.appendChild(card);
        });
        placeTrucks();
        var next = incoming.querySelector('[data-vpc-next]');
        if (next && next.getAttribute('href')) {
          nextBtn.setAttribute('href', next.getAttribute('href'));
          nextBtn.classList.remove('is-loading');
          nextBtn.textContent = 'Show more trucks';
        } else {
          stopPaging();
        }
      })
      .catch(function () {
        if (nextBtn) {
          nextBtn.classList.remove('is-loading');
          nextBtn.textContent = 'Show more trucks';
        }
      })
      .finally(function () {
        loading = false;
      });
  }

  function ensureAllLoaded() {
    if (!nextBtn) return Promise.resolve();
    return loadNext().then(function () {
      return nextBtn ? ensureAllLoaded() : Promise.resolve();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      loadNext().then(apply);
    });
  }

  if (sentinel && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext().then(apply);
        });
      },
      { rootMargin: '600px 0px' }
    );
    observer.observe(sentinel);
  }

  readURL();
  apply();
  ensureAllLoaded().then(apply);
})();
